import { ChangeDetectorRef } from '@angular/core';
import { registerBulkAction, addNavMenuSection } from '@vendure/admin-ui/core';
import {
    assignPromotionsToChannelBulkAction,
    deleteScratchPromosBulkAction,
    duplicatePromotionsBulkAction,
    removePromotionsFromChannelBulkAction,
} from './components/scratch-promos-list/scratch-promos-list-bulk-actions';
import { deleteScratchRewardsDealsBulkAction } from './components/scratch-rewards-list/scratch-rewards-list-bulk-actions';

export default [
    addNavMenuSection({
        id: 'scratch-promotions',
        label: 'Scratch Promotions',
        requiresPermission: 'ScratchRewardsControl',
        items: [
            {
                id: 'scratch-promos-list',
                label: 'Scratch Promos',
                routerLink: ['/extensions/scratch-promos/list'],
                icon: 'event',
            },
            {
                id: 'scratch-rewards-list',
                label: 'Scratch Rewards List',
                routerLink: ['/extensions/scratch-promos/rewards'],
                icon: 'eye',
            },
        ],
    }),

    registerBulkAction(deleteScratchPromosBulkAction),
    registerBulkAction(assignPromotionsToChannelBulkAction),
    registerBulkAction(removePromotionsFromChannelBulkAction),
    registerBulkAction(duplicatePromotionsBulkAction),

    registerBulkAction(deleteScratchRewardsDealsBulkAction),
];
